<template>
  <!-- 系统人员管理 -->
  <div style="margin-top: 50px">
    <!-- 列表页 -->
    <van-pull-refresh v-model="loadDataing" @refresh="onRefresh" loading-text="内容刷新中..." success-text="刷新成功">
      <van-list v-model="loading" :finished="finished" @offset="100" loading-text="内容加载中..."
        finished-text="—————— 没有更多了 ————————" @load="onLoad">
        <div class="box" v-for="item in allList" :key="item.id">
          <div class="topRow">
            <div class="topRowLeft" @click="goEditSystem(item)">
              <div>
                <img class="touXiangImg" :src="item.admin_picture" mode="" />
              </div>
              <div class="headLeft">
                <div class="name">
                  {{ item.user }}
                </div>
                <div>
                  <div class="car">{{ item.group_name || "---" }}</div>
                </div>
              </div>
            </div>
            <div class="topRowRight">
              <van-field name="switch" label="状态">
                <template #input>
                  <van-switch :value="item.status === '1' ? true : false" size="20" @click="clickSwtich(item)" />
                </template>
              </van-field>
            </div>
          </div>
          <div class="content">
            <div class="contentLeft" @click="goEditSystem(item)">
              <span class="userName"> 姓名: {{ item.username }}</span>
              <span class="lastTime">
                上次上线时间: {{ item.lastLoginTm }}</span>
            </div>
            <div class="contentRight">
              <van-button type="info" size="mini" style="width: 34px" @click="deleteItem(item)">删除</van-button>
              <!-- <van-popover
                v-model="item.showPopover"
                trigger="click"
                theme="dark"
                @select="selectPopover(actions, item)"
                :actions="actions"
                placement="left"
              >
                <template #reference>
                  <van-button type="info" size="mini" style="width: 34px"
                    >操作</van-button
                  >
                </template>
              </van-popover> -->
            </div>
          </div>
        </div>
        <div v-if="showAdd == false" class="van-empty">
          <div class="van-empty__image"><img src="../../../assets/icon/empty-image-default.png"></div>
          <p class="van-empty__description">您没有权限进行此操作！</p>
        </div>
      </van-list>
    </van-pull-refresh>
    <div v-if="showAdd" class="addBox" @click="goAddSystem">
      <div class="add">十</div>
    </div>

    <!-- <div class="noMore">———————— 没有更多了 ————————</div> -->
  </div>
</template>
<script>
import {
  deleteSysUserAPI,
  sysUserListAPI,
  editStatusAPI,
} from "@/api/systemPerson";
import { Toast, Dialog } from "vant";
export default {
  name: "AllTabContent",
  props: {},
  data() {
    return {
      uid: "",
      show: false,
      message: "",
      fieldValue: "", // 文章状态
      radio: "1",
      actions: [{ text: "删除" }],
      allList: [],
      loadDataing: false, // 下拉刷新是否处于加载中状态
      loading: false, //  列表是否处于加载状态，加载过程中不触发load事件
      finished: false, //  是否已加载完成，加载完成后不再触发load事件
      page: 1, // 当前第几页
      pageSize: 10, // 一页请求多少条数据
      total: 0, // 总共多少条
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
      nodata: false, // 请求接口是否没有数据
      showAdd: false,
    };
  },
  activated() {
    this.pageView();
  },
  methods: {
    clickSwtich(item) {
      if (item.status === "1") {
        Dialog.confirm({
          title: "操作",
          message: `你确定将${item.user}账号，状态改为不可用吗?`,
        })
          .then(() => {
            const data = {
              admin_id: item.admin_id,
              status: 0,
            };
            editStatusAPI(data).then((res) => {
              if (res.data.status === 1) {
                Toast.success("操作成功");
                this.pageView();
              }
            });
          })
          .catch(() => { });
      } else {
        Dialog.confirm({
          title: "操作",
          message: `你确定将${item.user}账号恢复吗?`,
        })
          .then(() => {
            const data = {
              admin_id: item.admin_id,
              status: 1,
            };
            editStatusAPI(data).then((res) => {
              if (res.data.status === 1) {
                Toast.success("操作成功");
                this.pageView();
              }
            });
          })
          .catch(() => { });
      }
    },
    // 下拉刷新(相当于重新请求第一页)
    onRefresh() {
      this.page = 1;
      this.pageSize = 10;
      this.allList = [];
      this.loadDataing = true;
      this.onLoad();
    },
    pageView() {
      this.page = 1;
      this.finished = false;
      this.loading = true;
      const data = {
        curr: 1,
        nums: 10,
      };
      this.allList = [];
      Toast.loading({ message: "数据加载中...", forbidClick: true });
      sysUserListAPI(data)
        .then((res) => {
          if (res.data.code === 0) {
            this.allList = res.data?.data || [];
            this.total = res.data.count;
          }
          if (this.allList?.length === this.total) {
            this.finished = true;
          }
          this.loading = false;
          this.loadDataing = false;
        })
        .finally(() => {
          Toast.clear();
        });
    },
    // 滚动条与底部距离小于 offset 时触发
    onLoad() {
      this.finished = false;
      this.loading = true;
      let data = {
        curr: this.page++,
        nums: this.pageSize,
      };
      sysUserListAPI(data)
        .then((res) => {
          if (res.data.code === 0) {
            this.showAdd = true;
            this.getList(res.data);
            this.total = res.data.count;
          }
          if (this.allList?.length === this.total) {
            this.finished = true;
          }
          this.loading = false;
          this.loadDataing = false;
          Toast.clear();
        })
        .finally(() => { });
    },
    getList(data) {
      data.data.map((item) => {
        this.allList.push({
          ...item,
        });
      });
    },
    goEditSystem(item) {
      this.$router.push({
        path: "/editSystemPerson",
        query: {
          admin_id: item.admin_id,
          group_name: item.group_name,
        },
      });
    },
    goAddSystem() {
      this.$router.push({ path: "/addSystemPerson" });
    },
    caseFieldValue(state) {
      const stateList = {
        1: "待审核",
        2: "通过",
        3: "不通过",
      };
      return stateList[state] ? stateList[state] : "";
    },
    deleteItem(item) {
      Dialog.confirm({
        title: "操作",
        message: "你确定删除该系统人员吗？",
      })
        .then(() => {
          const data = { admin_id: item.admin_id };
          deleteSysUserAPI(data).then((res) => {
            if (res.data.status === 1) {
              Toast.success("删除成功");
              setTimeout(() => {
                this.pageView();
              }, 300);
            }
          });
        })
        .catch(() => { });
    },
    selectPopover(actions, item) {
      if (actions[0].text === "删除") {
        Dialog.confirm({
          title: "操作",
          message: "你确定删除该系统人员吗？",
        })
          .then(() => {
            const data = { admin_id: item.admin_id };
            deleteSysUserAPI(data).then((res) => {
              if (res.data.status === 1) {
                Toast.success("删除成功");
                setTimeout(() => {
                  this.pageView();
                }, 300);
              }
            });
          })
          .catch(() => { });
      }
    },
  },
};
</script>
<style scoped lang="less">
.box {
  padding: 0px 30px;
  min-height: 200px;
  margin: 32px 0px;
  border-bottom: 2px solid #ececec;
}

.topRow {
  display: flex;
  justify-content: space-between;

  .topRowLeft {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .touXiangImg {
      width: 100px;
      height: 100px;
      border-radius: 50%;
    }

    .headLeft {
      margin-left: 30px;

      .name {
        font-weight: 500;
        font-size: 30px;
      }

      .car {
        padding: 0px 12px;
        color: #b77d43;
        background-color: #f4f0e4;
        // width: 105px;
        height: 40px;
        line-height: 40px;
        font-size: 24px;
        text-align: center;
        margin-top: 8px;
        // border-radius: 32px;
      }
    }
  }

  .topRowRight {
    color: red;
    font-size: 24px;
    margin-top: 10px;

    /deep/ .van-field__label {
      width: 60px !important;
    }
  }
}

.content {
  display: flex;
  justify-content: space-between;
  margin: 20px 0px;
  height: 56px;
  align-items: center;
  color: gray;

  .contentLeft {
    .userName {
      color: black;
    }

    .lastTime {
      margin-left: 5px;
    }
  }

  .contentRight {
    .iconMore {
      display: flex;
      justify-content: flex-end;

      img {
        width: 35px;
        height: 35px;
      }
    }
  }
}

.timeBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;

  .time {
    font-size: 24px;
    color: #6b6b6b;
  }

  .iconMore {
    display: flex;
    justify-content: flex-end;

    img {
      width: 35px;
      height: 35px;
    }
  }
}

/* 弹框层样式 */
.bottomModal {
  display: flex;
  height: 100px;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  font-size: 36px;
}

.radioItem {
  height: 120px;
  line-height: 120px;
  font-size: 30px;
}

.btnRow {
  display: flex;
  flex-wrap: nowrap;

  .resetBtn {
    flex: 1;
  }

  .okBtn {
    flex: 2;
  }
}

.noMore {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  color: #6b6b6b;
}

/deep/.van-overlay {
  // top: calc(100vh-250px);
  top: 250px !important;
}

/deep/ .van-popup--top {
  top: 248px !important;
}

.addBox {
  position: fixed;
  bottom: 50px;
  right: 150px;

  .add {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    background: rgb(72, 113, 192);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 50px;
  }
}
</style>